/**
 * JavaScript Utility - isJSON
 * @author 서명환 <mhseo@ulalalab.com>
 */
import isObject from './isObject';

function isJSON(value) {
  return Array.isArray(value) || isObject(value);
}

export default isJSON;
